'use strict';

import GraphQL from './graphql';

export default {

  create(squad) {
    let args = [];
    args.unshift(`firstName: "${squad.firstName}"`);
    args.unshift(`lastName: "${squad.lastName}"`);
    args.unshift(`zip: "${squad.zip}"`);
    args.unshift(`email: "${squad.email}"`);

    // Optional Fields
    if (!!squad.squadName) {
      args.unshift(`squadName: "${squad.squadName}"`);
    }
    if (!!squad.phone) {
      args.unshift(`phone: "${squad.phone}"`);
    }
    if (!!squad.sms) {
      args.unshift(`sms: ${squad.sms}`);
    }
    if (!!squad.districtId) {
      args.unshift(`districtId: ${squad.districtId}`);
    }
    if (!!squad.organizationName) {
      args.unshift(`organizationName: "${squad.organizationName}"`);
    }
    if (!!squad.name) {
      args.unshift(`name: "${squad.name}"`);
    }
    if (!!squad.website) {
      args.unshift(`website: "${squad.website}"`);
    }

    args = args.join(', ');

    const query = `mutation {
      createSquad(${args}) {
        id
        errors
      }
    }`;

    return GraphQL.post(query);
  },

  join(squad, data) {
    const query = `mutation {
      joinSquad(squadId:${squad.id}, email:"${data.email}", name: "${data.name}")
    }`;

    return GraphQL.post(query);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/squads.js